export default __webpack_public_path__ + "static/media/logo-hubcare-gestao-saude.23a1acd1.png";